/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: Tom (https://sketchfab.com/trbaker)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/imaginary-city-i-f6b1fae536c8490ca09b28db95586b1c
title: Imaginary city I
*/

import { useGLTF } from "@react-three/drei";

export function City(props) {
  const { nodes, materials } = useGLTF("/assets/imaginary_city_i.glb");
  return (
    <group {...props} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]} scale={0.16}>
        <group rotation={[Math.PI / 2, 0, 0]}>
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_16_m_CityEngineMaterial_16_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_140_m_CityEngineMaterial_140_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_138_m_CityEngineMaterial_138_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_135_mat}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_139_m_CityEngineMaterial_139_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_143_m_CityEngineMaterial_143_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_0}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_141_m_CityEngineMaterial_141_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_135_mat_0}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_142_m_CityEngineMaterial_142_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_112_m_CityEngineMaterial_112_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_1}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_111_m_CityEngineMaterial_111_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_12_m_CityEngineMaterial_12_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_20_m_CityEngineMaterial_20_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_87_m_CityEngineMaterial_87_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_3}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_53_m_CityEngineMaterial_53_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_105_m_CityEngineMaterial_105_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_4}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_74_m_CityEngineMaterial_74_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_5}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_6_m_CityEngineMaterial_6_mat_0.geometry
            }
            material={materials.CityEngineMaterial_1_mat}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_127_m_CityEngineMaterial_127_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_6}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_m_CityEngineMaterial_mat_0.geometry
            }
            material={materials.CityEngineMaterial_1_mat_0}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_32_m_CityEngineMaterial_32_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_1_m_CityEngineMaterial_1_mat_0.geometry
            }
            material={materials.CityEngineMaterial_1_mat_1}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_95_m_CityEngineMaterial_95_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_38_m_CityEngineMaterial_38_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_2_m_CityEngineMaterial_2_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_7}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_31_m_CityEngineMaterial_31_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_8}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_68_m_CityEngineMaterial_68_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_9}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_21_m_CityEngineMaterial_21_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_8_m_CityEngineMaterial_8_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_34_m_CityEngineMaterial_34_mat_0.geometry
            }
            material={materials.CityEngineMaterial_135_mat_1}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_7_m_CityEngineMaterial_7_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_51_m_CityEngineMaterial_51_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_52_m_CityEngineMaterial_52_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_108_m_CityEngineMaterial_108_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_10}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_37_m_CityEngineMaterial_37_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_89_m_CityEngineMaterial_89_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_75_m_CityEngineMaterial_75_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_110_m_CityEngineMaterial_110_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_29_mat}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_14_m_CityEngineMaterial_14_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_9_m_CityEngineMaterial_9_mat_0.geometry
            }
            material={materials.CityEngineMaterial_1_mat_2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_15_m_CityEngineMaterial_15_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_113_m_CityEngineMaterial_113_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_103_mat}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_13_m_CityEngineMaterial_13_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_11_m_CityEngineMaterial_11_mat_0.geometry
            }
            material={materials.CityEngineMaterial_1_mat_3}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_109_m_CityEngineMaterial_109_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_10_m_CityEngineMaterial_10_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_5_m_CityEngineMaterial_5_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_3_m_CityEngineMaterial_3_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_11}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_4_m_CityEngineMaterial_4_mat_0.geometry
            }
            material={materials.CityEngineMaterial_1_mat_4}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_43_m_CityEngineMaterial_43_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_39_m_CityEngineMaterial_39_mat_0.geometry
            }
            material={materials.CityEngineMaterial_135_mat_2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_42_m_CityEngineMaterial_42_mat_0.geometry
            }
            material={materials.CityEngineMaterial_135_mat_3}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_40_m_CityEngineMaterial_40_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_12}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_41_m_CityEngineMaterial_41_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_13}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_44_m_CityEngineMaterial_44_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_123_m_CityEngineMaterial_123_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_14}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_122_m_CityEngineMaterial_122_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_121_m_CityEngineMaterial_121_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_103_mat_0}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_148_m_CityEngineMaterial_148_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_49_m_CityEngineMaterial_49_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_15}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_47_m_CityEngineMaterial_47_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_48_m_CityEngineMaterial_48_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_46_m_CityEngineMaterial_46_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_16}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_45_m_CityEngineMaterial_45_mat_0.geometry
            }
            material={materials.CityEngineMaterial_135_mat_4}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_100_m_CityEngineMaterial_100_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_99_m_CityEngineMaterial_99_mat_0.geometry
            }
            material={materials.CityEngineMaterial_159_mat}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_98_m_CityEngineMaterial_98_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_17}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_101_m_CityEngineMaterial_101_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_18}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_97_m_CityEngineMaterial_97_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_19}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_96_m_CityEngineMaterial_96_mat_0.geometry
            }
            material={materials.CityEngineMaterial_159_mat_0}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_132_m_CityEngineMaterial_132_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_20}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_133_m_CityEngineMaterial_133_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_21}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_131_m_CityEngineMaterial_131_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_135_mat_5}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_90_m_CityEngineMaterial_90_mat_0.geometry
            }
            material={materials.CityEngineMaterial_29_mat_0}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_91_m_CityEngineMaterial_91_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_22}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_92_m_CityEngineMaterial_92_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_23}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_126_m_CityEngineMaterial_126_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_103_mat_1}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_128_m_CityEngineMaterial_128_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_24}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_161_m_CityEngineMaterial_161_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_158_m_CityEngineMaterial_158_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_160_m_CityEngineMaterial_160_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_155_m_CityEngineMaterial_155_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_157_m_CityEngineMaterial_157_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_25}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_154_m_CityEngineMaterial_154_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_26}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_150_m_CityEngineMaterial_150_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_153_m_CityEngineMaterial_153_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_152_m_CityEngineMaterial_152_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_135_mat_6}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_151_m_CityEngineMaterial_151_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_27}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_149_m_CityEngineMaterial_149_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_135_mat_7}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_19_m_CityEngineMaterial_19_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_28}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_17_m_CityEngineMaterial_17_mat_0.geometry
            }
            material={materials.CityEngineMaterial_135_mat_8}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_18_m_CityEngineMaterial_18_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_29}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_60_m_CityEngineMaterial_60_mat_0.geometry
            }
            material={materials.CityEngineMaterial_103_mat_2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_64_m_CityEngineMaterial_64_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_58_m_CityEngineMaterial_58_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_59_m_CityEngineMaterial_59_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_57_m_CityEngineMaterial_57_mat_0.geometry
            }
            material={materials.CityEngineMaterial_103_mat_3}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_54_m_CityEngineMaterial_54_mat_0.geometry
            }
            material={materials.CityEngineMaterial_103_mat_4}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_56_m_CityEngineMaterial_56_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_63_m_CityEngineMaterial_63_mat_0.geometry
            }
            material={materials.CityEngineMaterial_103_mat_5}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_55_m_CityEngineMaterial_55_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_62_m_CityEngineMaterial_62_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_30}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_65_m_CityEngineMaterial_65_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_31}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_61_m_CityEngineMaterial_61_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_103_m_CityEngineMaterial_103_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_103_mat_6}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_106_m_CityEngineMaterial_106_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_32}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_107_m_CityEngineMaterial_107_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_33}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_104_m_CityEngineMaterial_104_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_103_mat_7}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_82_m_CityEngineMaterial_82_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_34}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_80_m_CityEngineMaterial_80_mat_0.geometry
            }
            material={materials.CityEngineMaterial_135_mat_9}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_79_m_CityEngineMaterial_79_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_35}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_81_m_CityEngineMaterial_81_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_36}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_78_m_CityEngineMaterial_78_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_77_m_CityEngineMaterial_77_mat_0.geometry
            }
            material={materials.CityEngineMaterial_135_mat_10}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_137_m_CityEngineMaterial_137_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_30_m_CityEngineMaterial_30_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_37}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_29_m_CityEngineMaterial_29_mat_0.geometry
            }
            material={materials.CityEngineMaterial_29_mat_1}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_159_m_CityEngineMaterial_159_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_159_mat_1}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_115_m_CityEngineMaterial_115_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_38}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_114_m_CityEngineMaterial_114_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_163_m_CityEngineMaterial_163_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_39}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_164_m_CityEngineMaterial_164_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_40}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_88_m_CityEngineMaterial_88_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_41}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_86_m_CityEngineMaterial_86_mat_0.geometry
            }
            material={materials.CityEngineMaterial_135_mat_11}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_83_m_CityEngineMaterial_83_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_84_m_CityEngineMaterial_84_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_42}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_85_m_CityEngineMaterial_85_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_43}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_50_m_CityEngineMaterial_50_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_102_m_CityEngineMaterial_102_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_35_m_CityEngineMaterial_35_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_36_m_CityEngineMaterial_36_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_44}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_134_m_CityEngineMaterial_134_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_66_m_CityEngineMaterial_66_mat_0.geometry
            }
            material={materials.CityEngineMaterial_135_mat_12}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_67_m_CityEngineMaterial_67_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_156_m_CityEngineMaterial_156_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_159_mat_2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_125_m_CityEngineMaterial_125_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_124_m_CityEngineMaterial_124_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_159_mat_3}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_28_m_CityEngineMaterial_28_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_130_m_CityEngineMaterial_130_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_129_m_CityEngineMaterial_129_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_22_m_CityEngineMaterial_22_mat_0.geometry
            }
            material={materials.CityEngineMaterial_29_mat_2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_24_m_CityEngineMaterial_24_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_45}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_25_m_CityEngineMaterial_25_mat_0.geometry
            }
            material={materials.CityEngineMaterial_29_mat_3}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_23_m_CityEngineMaterial_23_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_46}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_27_m_CityEngineMaterial_27_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_26_m_CityEngineMaterial_26_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_94_m_CityEngineMaterial_94_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_47}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_93_m_CityEngineMaterial_93_mat_0.geometry
            }
            material={materials.CityEngineMaterial_29_mat_4}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_70_m_CityEngineMaterial_70_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_71_m_CityEngineMaterial_71_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_48}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_69_m_CityEngineMaterial_69_mat_0.geometry
            }
            material={materials.CityEngineMaterial_79_mat_49}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_162_m_CityEngineMaterial_162_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_119_m_CityEngineMaterial_119_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_103_mat_8}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_117_m_CityEngineMaterial_117_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_50}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_116_m_CityEngineMaterial_116_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_103_mat_9}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_120_m_CityEngineMaterial_120_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_118_m_CityEngineMaterial_118_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_51}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_72_m_CityEngineMaterial_72_mat_0.geometry
            }
            material={materials.CityEngineMaterial_29_mat_5}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_73_m_CityEngineMaterial_73_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_136_m_CityEngineMaterial_136_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_79_mat_52}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_135_m_CityEngineMaterial_135_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_135_mat_13}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_145_m_CityEngineMaterial_145_mat_0
                .geometry
            }
            material={materials.CityEngineMaterial_135_mat_14}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_146_m_CityEngineMaterial_146_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_147_m_CityEngineMaterial_147_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_144_m_CityEngineMaterial_144_mat_0
                .geometry
            }
            material={materials.Merged_materials}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes.CityEngineMaterial_76_m_CityEngineMaterial_76_mat_0.geometry
            }
            material={materials.Merged_materials}
          />
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("/assets/imaginary_city_i.glb");
